// extracted by mini-css-extract-plugin
export default {"container":"style_container__JJQRM","header":"style_header__55Ru4","buttonsContainer":"style_buttonsContainer__UDmvw"};